import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ModuleRegistry } from '@ag-grid-community/core';
import { useSelector, useDispatch } from 'react-redux';
import { getUserList } from '../../redux/selector';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';

import { DateFormatter } from '../../shared/controls/formatters';
import apiServices from '../../services/service';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { tr } from 'date-fns/locale';
import { Modal, Dropdown, Form, Badge, Stack } from 'react-bootstrap';
import AddUserForm from './addUserForm';
import ChangePasswordModal from '../settings/changePassword/changePassword';
import changePwdIcon from "../../assets/img/sidemenu/change_pwd.svg";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  RangeSelectionModule,
  RowGroupingModule,
  RichSelectModule,
]);

const OptionButton = ({ rowData, handleClickOpenEditForm, handleUpdateUser, paramsValue }) => {
  // const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [isActive, setIsActive] = useState(rowData.isActive);
  const [loading, setLoading] = useState(false);
  const handleToggleChange = async (e) => {
    const newStatus = e.target.checked; // Get new toggle status
    setIsActive(newStatus); // Update local state
    // Prepare data for API call
    const data = { userId: rowData.userId, isActive: newStatus }; // Adjust based on your data structure
    handleUpdateUser(data);
    setLoading(true); // Set loading true while waiting for the response
  };
  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleClickOpenEditForm(rowData)}
        alt="Edit User"
        title="Edit User"
      ></img>
      <label className="switch">
        <input
          type="checkbox"
          checked={isActive}
          onChange={handleToggleChange}
          disabled={loading} // Disable toggle while processing
          title={isActive ? 'Active User' : 'Inactive User'}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

const ManageRoles = ({ rowData, setUpdateListFlag }) => {
  const [showPopover, setShowPopover] = useState(false);
  // const [roleListDropDown, setRoleListDropDown] = useState([]);

  const handleButtonClick = () => {
    setShowPopover(true);
  };

  const handleClosePopover = () => {
    setShowPopover(false);
  };

  const RolesModal = (show) => {
    const [selectedRoleIDs, setSelectedRoleIDs] = useState(
      rowData ? rowData.roles.map((role) => role.id) : []
    );
    const [loading, setLoading] = useState(false);
    const [roleListDropDown, setRoleListDropDown] = useState([]);
    // const [roleId, setRoleId] = useState(rowData ? rowData.userId : [])
    const userId = rowData ? rowData.userId : [];
    const handleCheckboxChange = (roleId) => {
      const updatedSelectedRoleIDs = selectedRoleIDs.includes(roleId)
        ? selectedRoleIDs.filter((id) => id !== roleId)
        : [...selectedRoleIDs, roleId];

      setSelectedRoleIDs(updatedSelectedRoleIDs);
    };

    const handleRemoveRole = (selectedId) => {
      const updatedSelectedRoleIDs = selectedRoleIDs.filter((id) => id !== selectedId);
      setSelectedRoleIDs(updatedSelectedRoleIDs);
    };

    useEffect(() => {
      setLoading(true);
      const roleOrder = [
        'CEO',
        'General Manager',
        'Manager',
        'Senior Executive',
        'Executive',
        'User',
        'System Manager',
        'Admin',
      ];
      apiServices
        .getRoleList()
        .then((response) => {
          if (response.status === 200) {
            const fetchedRoles = response.data.rolesList;

            // Sort roles based on predefined order
            const sortedRoles = roleOrder
              .map((roleName) => fetchedRoles.find((role) => role.roleName === roleName))
              .filter(Boolean); // Filter out any undefined entries (for roles not in the response)

            setRoleListDropDown(sortedRoles);
            setLoading(false);
          } else {
            // Handle other status codes
            toast.error(`An unexpected error occurred: ${response.status}`, {
              position: 'top-right',
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error('Error uploading file:', error);
          // Handle errors
          setLoading(false);
        });
    }, []);

    const handleSubmitUserRoles = () => {
      setLoading(true);
      setUpdateListFlag(true);
      // Create an array of role objects containing only the IDs
      const roles = selectedRoleIDs;
      // Create the JSON object with roles and userId
      const userData = {
        roleIds: roles,
        userId: userId,
      };
      apiServices.manageUserRoles(userData).then((response) => {
        if (response.status === 200) {
          // apiServices.manageUpsetUserRoles(userIdUpset);
          handleClosePopover();
          setUpdateListFlag(false);
          toast.success('Roles updated successfully!', {
            position: 'top-right',
          });
          setLoading(false);
        } else {
          const errorMessages = [];
          setLoading(false);
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      });
    };

    return (
      <>
        <div>
          <Modal show={show} onHide={handleClosePopover} id="mange_roles">
            {loading && <Loader />}
            <Modal.Header closeButton>
              <Modal.Title>Please Select Roles</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '50vh' }}>
              <div className="role-dropdown">
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {selectedRoleIDs?.length > 0 ? (
                      <Stack direction="horizontal" gap={2}>
                        {selectedRoleIDs.map((selectedRoleId) => {
                          const selectedRole = roleListDropDown.find(
                            (role) => role.id === selectedRoleId
                          );
                          return (
                            <Badge bg="primary" key={selectedRoleId} className="selected-role">
                              <span className="multi-select">{selectedRole?.roleName}</span>
                              {selectedRole?.roleName !== 'User' && (
                                <span
                                  className="close-button"
                                  onClick={() => handleRemoveRole(selectedRoleId)}
                                >
                                  x
                                </span>
                              )}
                            </Badge>
                          );
                        })}
                      </Stack>
                    ) : (
                      'Select Roles'
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu">
                    {roleListDropDown.map((data, index) => (
                      <React.Fragment key={data.id}>
                        {/* Add dotted line just before the last two items */}
                        {index === roleListDropDown.length - 2 && (
                          <div
                            style={{
                              borderTop: '1px dotted #ccc',
                              margin: '8px 0',
                            }}
                          ></div>
                        )}

                        <div className="role-checkbox">
                          <div className="label-and-checkbox">
                            <Form.Check
                              type="checkbox"
                              id={`roleCheckbox-${data.id}`}
                              label={data.roleName}
                              checked={selectedRoleIDs.includes(data.id)}
                              onChange={() => handleCheckboxChange(data.id)}
                              disabled={data.roleValue === 'User'}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-primary" onClick={handleSubmitUserRoles}>
                Apply
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                onClick={handleClosePopover}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="action-menu">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-gear-fill"
          viewBox="0 0 16 16"
          onClick={handleButtonClick}
        >
          <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z" />
        </svg>
        {/* <button
                className="action-img-roles"
                onClick={handleButtonClick}
                alt="Manage Roles"
                title="Manage Roles"
            >
            Manage Roles 
            </button> */}
        {showPopover && <RolesModal />}
      </div>
    </>
  );
};

const initialValue = {
  empId: '',
  userName: '',
  mobile: '',
  email: '',
  oid: '',
  given_name: '',
  family_name: '',
  preferred_username: '',
  firstName: '',
  lastName: '',
  secondaryEmail: '',
  phoneNumber: '',
  extension: '',
  display_name: '',
  roles: [],
};

function UserManagementList() {
  // const themeValue = localStorage.getItem("selectedGridTheme");
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const userList = useSelector(getUserList);
  const [rowData, setRowData] = useState(userList);
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'userList');
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const gridApiRef = useRef(null);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [updateListFlag, setUpdateListFlag] = useState(false);
  const dispatch = useDispatch();
  const [buttontype, setbuttontype] = useState(null);
  const [userData, setUserData] = useState();
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    params.api.sizeColumnsToFit();
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true,
    // allow every column to be aggregated
    enableValue: true,
    // allow every column to be grouped
    // enableRowGroup: true,
    // allow every column to be pivoted
    enablePivot: true,
  }));

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
  }, []);
  const cellClickedListener = useCallback((event) => { }, []);
  const isMobile = () => {
    return window.innerWidth <= 767;
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <OptionButton
            rowData={paramsValue}
            openPopup={open}
            handleClickOpenEditForm={() => handleClickOpenEditForm(paramsValue)}
            handleUpdateUser={handleUpdateUser}
          />
        );
      },
      maxWidth: 82,
      minWidth: 82,
      sortable: false,
      filter: false,
      pinned: 'left',
      lockPosition: 'left',
    },
    {
      headerName: 'First Name',
      field: 'firstName',
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
      toolPanelParams: {
        suppressValues: true, // Prevent this column from being hidden in the Columns panel
      },
      lockVisible: true, // Keep the column scrollable but prevent it from being hidden
      suppressColumnsToolPanel: false, // Hide the column from the Columns Tool Panel
      pinned: isMobile() ? null : 'left',
      minWidth: 180,
    },
    {
      headerName: 'Manage Roles',
      cellStyle: { justifyContent: 'center' },
      field: 'roles',

      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return <ManageRoles rowData={paramsValue} setUpdateListFlag={setUpdateListFlag} />;
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
    },
    {
      headerName: "Change Password",
      field: "roles",
      maxWidth: 137,
      sortable: false,
      filter: false,
      cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },

      cellRenderer: (params) => {
        const row = params.data;

        // 🟢 if DB user → show icon
        if (row?.auth_type?.toLowerCase() === "db") {
          return (
            <img
              src={changePwdIcon}
              alt="change password"
              width={18}
              style={{ cursor: "pointer" }}
              title="Change Password"
              onClick={() => {
                setSelectedUser(row);
                setPasswordModalOpen(true);
              }}
            />
          );
        }

        // 🔵 if Azure user → show text
        return (
          <span style={{ fontSize: "12px", color: "#888", fontWeight: 500 }}>
            N/A
          </span>
        );
      },
    },
    {
      headerName: 'Last Name',
      field: 'lastName',
      tooltipField: 'displayName',
      filter: 'agTextColumnFilter',
      minWidth: 140,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Display Name',
      field: 'display_name',
      tooltipField: 'Display Name',
      minWidth: 250,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
      toolPanelParams: {
        suppressValues: true, // Prevent this column from being hidden in the Columns panel
      },
      lockVisible: true, // Keep the column scrollable but prevent it from being hidden
      suppressColumnsToolPanel: false, // Hide the column from the Columns Tool Panel
    },
    {
      headerName: 'Emp ID',
      field: 'empId',
      tooltipField: 'Employee ID',
      minWidth: 80,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
      toolPanelParams: {
        suppressValues: true, // Prevent this column from being hidden in the Columns panel
      },
      lockVisible: true, // Keep the column scrollable but prevent it from being hidden
      suppressColumnsToolPanel: false, // Hide the column from the Columns Tool Panel
    },

    {
      headerName: 'User Name',
      field: 'email',
      tooltipField: 'User Name',
      minWidth: 250,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
      toolPanelParams: {
        suppressValues: true, // Prevent this column from being hidden in the Columns panel
      },
      lockVisible: true, // Keep the column scrollable but prevent it from being hidden
      suppressColumnsToolPanel: false, // Hide the column from the Columns Tool Panel
    },
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 250,
      tooltipField: 'Email',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Business Unit',
      field: 'businessUnit',
      tooltipField: 'businessUnit',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Created On',
      field: 'createdDateTime',
      valueFormatter: DateFormatter,
      //tooltipField: "displayName",
      filter: 'agTextColumnFilter',
      minWidth: 140,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Status',
      field: 'isActive',
      tooltipField: 'isActive',
      filter: 'agTextColumnFilter',
      minWidth: 140,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        textCustomComparator: function (filter, value, filterText) {
          const formattedValue = value === 'true' ? 'active' : 'inactive';
          return formattedValue.indexOf(filterText) >= 0;
        },
      },
      cellRenderer: function (params) {
        return params.value ? 'Active' : 'Inactive';
      },
      valueFormatter: function (params) {
        return params.value ? 'Active' : 'Inactive';
      },
    },
  ]);

  const handleUpdateUser = (data) => {
    setLoading(true); // Set loading true while waiting for the response
    apiServices
      .inActiveUser(data)
      .then((response) => {
        if (response?.status === 200) {
          toast.success(`User ${data?.isActive ? 'Activated' : 'Deactivated'} Successfully!`, {
            position: 'top-right',
          });
          setUpdateListFlag(true); // Add this line if you need to trigger an update in the user list
          setLoading(false);
        } else {
          toast.error('Failed to update user status!', { position: 'top-right' });
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error updating user status:', error);
        toast.error('Failed to update user status!', { position: 'top-right' });
        setLoading(false);
      });
  };

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      // defaultToolPanel: 'filters',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    setRowData(userList);
  }, [userList, dispatch, updateListFlag]);

  useEffect(() => {
    if (!userList || userList.length === 0 || updateListFlag) {
      dispatch(fetchDataAndUpdateStore({ key: 'userList' }));
      setUpdateListFlag(false); // Reset the flag after fetching data
    }
  }, [dispatch, updateListFlag, userList]);

  const handleOpenAddForm = () => {
    setbuttontype('add');
    setUserData({ ...initialValue, type: 'add' });
    setOpen(true);
  };

  const handleClickOpenEditForm = (paramsValue) => {
    setbuttontype('edit');
    setUserData({ ...paramsValue, type: 'edit' });
    setOpen(true);
  };

  const handleCloseAddForm = () => {
    setOpen(false);
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);

    const editedFormData = { ...formData };
    editedFormData.mobile = formData.phoneNumber; // Copy phoneNumber to mobile
    editedFormData.display_name = formData.userName; // Copy userName to display_name

    if (editedFormData.type === 'edit') {
      const userUpdateData = {
        userId: editedFormData?.userId,
        phoneNumber: editedFormData?.phoneNumber,
        email: editedFormData?.email,
        empId: editedFormData?.empId,
        designationId: editedFormData?.designationId,
        firstName: editedFormData?.firstName,
        lastName: editedFormData?.lastName,
        auth_type: editedFormData?.auth_type,
        password: editedFormData?.password
      };
      apiServices
        .updateUser(userUpdateData)
        .then((response) => {
          if (response.status === 200) {
            setOpen(false);
            setUpdateListFlag(true);
            toast.success('User Updated successfully!', {
              position: 'top-right',
            });
            setLoading(false);
          } else {
            const errorMessages = [];
            setOpen(false);
            setLoading(false);
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code
            const status = error.response.status;

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
            // If there are no specific error messages, show a generic error
            // toast.error(`${error.response.status} An unexpected error occurred`, {position:"top-right" });
            setLoading(false);
          }
        });
    } else {
      const newObj1 = { ...editedFormData };
      delete newObj1.type;
      delete newObj1.flagName;

      const mobile = newObj1.phoneNumber;
      newObj1.mobile = newObj1.phoneNumber;
      const display_name = newObj1.userName;
      newObj1.display_name = newObj1.userName;
      apiServices
        .registerUser(newObj1)

        .then((response) => {
          if (response.status === 200) {
            const userId = {
              userId: response.data,
            };
            // apiServices.manageUpsetUserRoles(userId);
            setOpen(false);
            setUpdateListFlag(true);
            toast.success('User created successfully!', {
              position: 'top-right',
            });
            // setLoading(false)
          } else {
            setOpen(false);
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
          // else {
          //   // Handle other error cases
          //   toast.error('An error occurred while submitting the form.', {position:"top-right" });
          // }
        })
        .catch((error) => {
          //setOpen(false);
          setLoading(false);
          if (error.response && error.response.data.message) {
            const errors = error.response.data.message;
            // // Extract HTTP status code
            // const status = error.response.status;

            // Object.keys(errors).forEach((errorType) => {
            //   const errorMessages = errors[errorType];
            //   errorMessages.forEach((errorMessage) => {
            toast.error(` ${errors}`, {
              position: 'top-right',
            });
            //   });
            // });
          } else {
            toast.error(`${error?.response?.data?.title}`, { position: 'top-right' });
          }
        });
    }
  };

  const onFilterTextBoxChanged = useCallback(() => {
    gridRef?.current?.api?.setQuickFilter(document?.getElementById('filter-text-box')?.value);
  }, []);

  return (
    <>
      <div className="ViewLeadPageOuter">
        <div className="viewFormContainer">
          <div className="inner-page" style={containerStyle}>
            {/* <ToastContainer /> */}
            <div className="dash-container">
              <div className="tbl_container">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="main-hd">
                      <div className="pagetitle">
                        <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                        User
                        <div
                          style={{
                            marginLeft: '80px',
                            fontWeight: 'bold',
                            display: 'flex',
                            gap: '5px',
                            fontSize: '13px',
                          }}
                        ></div>
                      </div>
                      <div className="third-div mobView">
                        <input
                          className="form-control"
                          id="filter-text-box"
                          type="Text"
                          placeholder="Search in Users..."
                          onInput={onFilterTextBoxChanged}
                        />
                        <div className="heading_item">
                          <button
                            className="add-btn"
                            type="button"
                            onClick={handleOpenAddForm} // Only React state, no data-bs-toggle/data-bs-target
                          >
                            New User
                          </button>
                        </div>
                        {open && (
                          <div id="dropdown_modal">
                            <div className="modal show" tabIndex="-1" style={{ display: 'block' }}>
                              <AddUserForm
                                handleCloseAddForm={handleCloseAddForm}
                                handleFormSubmit={handleFormSubmit}
                                handleClickOpenEditForm={handleClickOpenEditForm}
                                userData={userData}
                                open={open}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="cutome_ag_theme">
                      <div
                        className={`ag-theme-${selectedTheme} tbl_height`}
                        style={{ width: '100%', height: `100%` }}
                      >
                        {loading ? (
                          <Loader />
                        ) : (
                          <AgGridReact
                            className="ag-grid-container" // Add a class for styling
                            // domLayout="autoHeight"
                            domLayout="fixedHeight"
                            ref={gridRef} // Ref for accessing Grid's API
                            rowData={rowData} // Row Data for Row
                            onGridReady={onGridReady}
                            columnDefs={columnDefs}
                            autoGroupColumnDef={autoGroupColumnDef}
                            defaultColDef={defaultColDef} // Default Column Properties
                            overlayLoadingTemplate={`<Loader />`}
                            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                            rowSelection={'multiple'} // Options - allows click selection of rows
                            statusBar={statusBar}
                            enableRangeSelection={true}
                            suppressExcelExport={true}
                            suppressRowClickSelection={true}
                            groupSelectsChildren={true}
                            pivotPanelShow={'always'}
                            popupParent={popupParent}
                            // sortingOrder={sortingOrder}
                            onFirstDataRendered={onFirstDataRendered}
                            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                            rowDragManaged={true}
                            suppressMoveWhenRowDragging={true} // to mange the design behaviour during the drag a column.
                            sideBar={sideBar}
                            // onSelectionChanged={onSelectionChanged}
                            alwaysShowVerticalScroll={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChangePasswordModal
        show={passwordModalOpen}
        selectedUser={selectedUser}
        onHide={() => setPasswordModalOpen(false)}
        changePasswordAdmin={true}
      />
    </>
  );
}
export default UserManagementList;
